import React, { useContext, useEffect, useLayoutEffect, useState } from 'react';
import { Tooltip as ReactTooltip } from 'react-tooltip'
import ToolTipWrapper from  '@/components/elements/Tooltip/ToolTipWrapper';
import { BuildPath } from  '@/helpers/Paths';
import { IBreakdownCompare, IUserDevices } from  '@/interfaces/insightsp2';
import { percent, direction } from  '@/helpers/Insights';
import PercentLabel from './PercentLabel';
import  '@/css/usersDevices.scss';
import { IInsightsContext, InsightsContext } from '@/context/InsightsContext';

const UsersDevices = ({data, dataDay2, compareDownloadLink}: {data:IUserDevices, dataDay2?:IUserDevices, compareDownloadLink?:string}) => {
    
    // Context 
    const context:IInsightsContext = useContext(InsightsContext);

    const [downloadLink, setDownloadLink] = useState<string>("");

    // Move in to single source
    useEffect(() => {

        // Build different download links - users has compare - overview single
        if (compareDownloadLink){
            setDownloadLink(compareDownloadLink);
        }
        else{
            setDownloadLink(data.csvDownload);
        }
    });

    // Inform context of render finished for loading
    useLayoutEffect(() => {
        context.loadTracker.dispatch({type: 'increment'})
    }, [data]);

    if (!data){
        return null
    }

    function singleVsCompare(field:string, label:string, showPercent?:boolean):JSX.Element {

        if (dataDay2){ 

            const day1No = data[field];
            const day2No = dataDay2[field];

            const dir = direction(day1No, day2No);
            
            const dataCompare:IBreakdownCompare = {
                image: null,
                percent:percent(day1No, day2No),
                day1No:day1No,
                day2No:day2No,
                label:null,
                ref:null,
                direction: dir
            }
        
            return (
                <div className="users-compare">
                    <div className={`percent ${dir}`}>
                        <PercentLabel item={dataCompare} />
                    </div>
                    <div className="compareOf">{data[field]}{showPercent?'%':''} vs {dataDay2[field]}{showPercent?'%':''}</div>
                    <div className="compareLabel">{label}</div>
                </div>
            )
        }        

        return (
            <h2><span>{data[field]}{showPercent?'%':''}</span> {label}</h2>
        )
    }

    return (
        <div className="UsersDevices">

            <div className="container">

                <section className="users">

                    <div className="title">
                        <h2>Users</h2>

                        <ToolTipWrapper id="insights-Users" className="insights-Users" >                     
                            <ReactTooltip place="top" className='thrive-tooltip' delayHide={1000}  id="insights-Users">
                                <span>The amount of new users who registered, and total users who logged in </span>
                            </ReactTooltip>
                        </ToolTipWrapper>
                        
                    </div>

                    <div className="cell">             
                        <div className="cell-image">
                            <img src={`${BuildPath()}/images/insightsp2/RegisteredUsers.png`} alt="" />
                        </div>
                        {singleVsCompare("usersRegistered", "Registered")}
                    </div>

                    <div className="cell">
                        <div className="cell-image">
                            <img src={`${BuildPath()}/images/insightsp2/LoggedInUsers.png`} alt="" />
                        </div>
                        {singleVsCompare("userLoggedIn", "Logged In")}
                    </div>

                </section>

                <section className="devices">

                    <div className="title">
                        <h2>Devices</h2>

                        <ToolTipWrapper id="insights-devices" className="insights-devices" >                     
                            <ReactTooltip place="top" className='thrive-tooltip' delayHide={1000}  id="insights-devices">
                                <span>The devices used by those who have logged in and registered in the chosen timeframe</span>
                            </ReactTooltip>
                        </ToolTipWrapper>
                        
                    </div>

                    <div className="cell">
                        <div className="cell-image">             
                            <img src={`${BuildPath()}/images/insightsp2/ios.svg`} alt="" />
                        </div>
                        {singleVsCompare("ios", "iOS", true)}
                    </div>

                    <div className="cell cell-android">  
                        <div className="cell-image">           
                            <img src={`${BuildPath()}/images/insightsp2/android.svg`} alt="" />
                        </div>
                        {singleVsCompare("android", "Android", true)}
                    </div>

                    <div className="cell">             
                        <div className="cell-image">
                            <img src={`${BuildPath()}/images/insightsp2/WebApp.svg`} alt="" />
                        </div>
                        {singleVsCompare("web", "Desktop", true)}
                    </div>
 
                    <div className="download">
                        <a className="download-stats" href={downloadLink}  aria-label='Download'>
                            <img src={`${BuildPath()}/images/insightsp2/DownloadStatsBtn.svg`} alt=""/>
                        </a>
                    </div>

                </section>
  
            </div>
       
        </div>
    );
};

export default UsersDevices;